// @flow

import { retailCashbookActions } from './retailCashbookActionCreator';

const filterTableDataRecievedFrom = (
  preFilteredData,
  recievedFromSelectedOption
) => {
  const searchString = recievedFromSelectedOption.toLowerCase().trim();

  let filteredArr;

  if (searchString) {
    filteredArr = preFilteredData.filter(
      row =>
        row.recievedFromName &&
        row.recievedFromName.toLowerCase().indexOf(searchString) >= 0
    );
  } else {
    filteredArr = preFilteredData;
  }

  return filteredArr;
};

const filterTableDataTranctionType = (
  preFilteredData,
  transactionTypeSelectedOption
) => {
  let filteredArr;

  if (
    transactionTypeSelectedOption &&
    transactionTypeSelectedOption === 'Debit'
  ) {
    filteredArr = preFilteredData.filter(
      row => row.remarks && row.remarks.indexOf('Handover') >= 0
    );
  } else if (
    transactionTypeSelectedOption &&
    transactionTypeSelectedOption === 'Credit'
  ) {
    filteredArr = preFilteredData.filter(
      row => row.remarks && row.remarks.indexOf('Handover') < 0
    );
  } else {
    filteredArr = preFilteredData;
  }

  return filteredArr;
};

const filterTableData = (newState, filterObj) => {
  let filteredArr;
  let transactionTypeFilteredArr;
  let recievedFromfilteredArr;

  if (filterObj.transactionTypeSelectedOption) {
    transactionTypeFilteredArr = filterTableDataTranctionType(
      newState.tableData,
      filterObj.transactionTypeSelectedOption
    );
  } else {
    transactionTypeFilteredArr = newState.tableData;
  }

  if (filterObj.recievedFromSelectedOption) {
    recievedFromfilteredArr = filterTableDataRecievedFrom(
      transactionTypeFilteredArr,
      filterObj.recievedFromSelectedOption
    );
  } else {
    recievedFromfilteredArr = transactionTypeFilteredArr;
  }

  if (filterObj.searchString) {
    const searchString = filterObj.searchString.toLowerCase().trim();
    filteredArr = recievedFromfilteredArr.filter(
      row =>
        (row.recievedFromName &&
          row.recievedFromName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.recievedFromMobile &&
          row.recievedFromMobile.toLowerCase().indexOf(searchString) >= 0) ||
        (row.recievedByName &&
          row.recievedByName.toLowerCase().indexOf(searchString) >= 0) ||
        (row.recievedByMobile &&
          row.recievedByMobile.toLowerCase().indexOf(searchString) >= 0) ||
        (row.transactionId &&
          row.transactionId.toLowerCase().indexOf(searchString) >= 0)
    );
  } else {
    filteredArr = recievedFromfilteredArr;
  }

  return filteredArr;
};

const initialState = {
  isLoading: false,
  isLoaded: false,
  tableData: null,
  tableDataFiltered: [],
  filterValues: {}
};

const retailCashbookReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case retailCashbookActions.GET_COLLECTIONS_CASHBOOK: {
      return Object.assign({}, state, action.payload);
    }
    case retailCashbookActions.GET_OVERALL_OUTSTANDING: {
      return Object.assign({}, state, action.payload);
    }
    case retailCashbookActions.FILTER_CASHBOOK_TABLE_DATA: {
      const newState = Object.assign({}, state);
      const filteredData = filterTableData(newState, action.payload);
      return Object.assign({}, state, { tableDataFiltered: filteredData });
    }
    case retailCashbookActions.SET_RTL_CASHBOOK_DATE_FILTER: {
      return Object.assign({}, state, {
        filterValues: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      });
    }
    case retailCashbookActions.OPEN_HANDOVER_TRANSACTION_MODAL: {
      return Object.assign({}, state, {
        showHandoverTransactionModal: action.payload,
        handoverTransactionTableData: action.payload.original
      });
    }
    default: {
      return state;
    }
  }
};

export default retailCashbookReducer;
